// extracted by mini-css-extract-plugin
export default {"gridItem":"GridItem_gridItem__tiFdC"};